import { useEffect, useState } from 'react';
import { featuredList } from '@/mocks/comics';

export default function Hero() {
  const [index, setIndex] = useState(0);
  const count = featuredList.length;

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % count), 5000);
    return () => clearInterval(timer);
  }, [count]);

  const current = featuredList[index];

  return (
    <section id="top" className="relative w-full bg-foreground-950 overflow-hidden">
      <img
        src={current.cover}
        alt={`${current.title}漫画首屏背景`}
        className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/80 to-foreground-950/40"></div>

      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16 flex flex-col lg:flex-row items-center gap-8">
        <div className="flex-1 text-center lg:text-left w-full">
          <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-5">
            <i className="ri-flashlight-fill"></i>
            本周精选
          </p>
          <h2 className="font-heading text-3xl md:text-5xl text-background-50 leading-tight">
            {current.title}
          </h2>
          <p className="mt-2 text-background-200/90 text-sm md:text-base">
            {current.author} · {current.category} · 共{current.chapters}话
          </p>
          <p className="mt-4 max-w-xl mx-auto lg:mx-0 text-background-100/85 text-sm md:text-base leading-relaxed">
            {current.description}
          </p>
          <div className="mt-4 flex flex-wrap justify-center lg:justify-start gap-2">
            {current.tags.map((tag) => (
              <span
                key={tag}
                className="px-2.5 py-1 rounded-full bg-background-50/15 text-background-50 text-xs border border-background-50/20"
              >
                {tag}
              </span>
            ))}
          </div>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 items-center justify-center lg:justify-start">
            <a
              href="#new"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-fill mr-1"></i>
              开始阅读
            </a>
            <a
              href="#categories"
              className="px-6 py-3 rounded-full bg-background-50/10 text-background-50 border border-background-50/25 text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap"
            >
              浏览分类
            </a>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            type="button"
            aria-label="上一部"
            onClick={() => setIndex((index - 1 + count) % count)}
            className="w-9 h-9 rounded-full bg-background-50/10 text-background-50 border border-background-50/20 flex items-center justify-center hover:bg-background-50/20 transition-colors"
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>

          <div className="relative w-40 md:w-52 aspect-[2/3] rounded-xl overflow-hidden border-2 border-background-50/30 shadow-2xl">
            <img src={current.cover} alt={`${current.title}漫画封面`} className="w-full h-full object-cover object-top" />
          </div>

          <button
            type="button"
            aria-label="下一部"
            onClick={() => setIndex((index + 1) % count)}
            className="w-9 h-9 rounded-full bg-background-50/10 text-background-50 border border-background-50/20 flex items-center justify-center hover:bg-background-50/20 transition-colors"
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>

      <div className="relative flex justify-center gap-2 pb-6">
        {featuredList.map((item, i) => (
          <button
            key={item.id}
            type="button"
            aria-label={`切换到${item.title}`}
            onClick={() => setIndex(i)}
            className={`h-2 rounded-full transition-all ${
              i === index ? 'w-8 bg-primary-400' : 'w-2 bg-background-50/30 hover:bg-background-50/50'
            }`}
          />
        ))}
      </div>
    </section>
  );
}